'use client';

import { useState, useEffect } from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface CartIndicatorProps {
  className?: string;
}

const CartIndicator = ({ className = '' }: CartIndicatorProps) => {
  const [cartCount, setCartCount] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    const updateCartCount = () => {
      const cart = JSON.parse(localStorage.getItem('cart') || '[]');
      const totalItems = cart.reduce((sum: number, item: any) => sum + (item.quantity || 1), 0);
      
      if (totalItems !== cartCount) {
        setIsAnimating(true);
        setCartCount(totalItems);
        setTimeout(() => setIsAnimating(false), 300);
      }
    };

    updateCartCount();

    window.addEventListener('storage', updateCartCount);
    window.addEventListener('cartUpdated', updateCartCount);

    const interval = setInterval(updateCartCount, 1000);

    return () => {
      window.removeEventListener('storage', updateCartCount);
      window.removeEventListener('cartUpdated', updateCartCount);
      clearInterval(interval);
    };
  }, [cartCount]);

  return (
    <Link data-component-id="src/components/common/CartIndicator.tsx:42:4" data-component-path="src/components/common/CartIndicator.tsx" data-component-line="42" data-component-end-line="57" data-component-file="CartIndicator.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22href%22%3A%22%2Fshopping-cart%22%7D"
      href="/shopping-cart"
      className={`relative p-2 rounded-md text-foreground hover:bg-primary/10 transition-smooth focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-2 ${className}`}
      aria-label={`Shopping cart with ${cartCount} items`}
    >
      <Icon data-component-id="src/components/common/CartIndicator.tsx:47:6" data-component-path="src/components/common/CartIndicator.tsx" data-component-line="47" data-component-end-line="47" data-component-file="CartIndicator.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22ShoppingCartIcon%22%7D" name="ShoppingCartIcon" size={24} />
      {cartCount > 0 && (
        <span data-component-id="src/components/common/CartIndicator.tsx:49:8" data-component-path="src/components/common/CartIndicator.tsx" data-component-line="49" data-component-end-line="55" data-component-file="CartIndicator.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
          className={`absolute -top-1 -right-1 min-w-[20px] h-5 px-1.5 flex items-center justify-center bg-accent text-accent-foreground text-xs font-bold rounded-full transition-spring ${
            isAnimating ? 'scale-110' : 'scale-100'
          }`}
        >
          {cartCount > 99 ? '99+' : cartCount}
        </span>
      )}
    </Link>
  );
};

export default CartIndicator;